class TextValidatorUtils {
    static checkIfLatinSign(sign) {
        let result = sign !== "" && sign !== null && sign !== undefined? sign.toString().match(/^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9.:;@!#$%&'*+-/=?^_`\\{|}\[\](\)~\s]+$/) !== null : true;
        return result;
    }
}

export default TextValidatorUtils;
